import { createSelector } from 'reselect';

const selectSettingsState = (state) => state.settingsReducer;
export const selectArchiveReturnStatuses = () =>
  createSelector(selectSettingsState, (state) => state.archiveReturnStatuses);
export const selectEstimation = () =>
  createSelector(selectSettingsState, (state) => state.estimation);
export const selectStates = () => createSelector(selectSettingsState, (state) => state.states);
export const selectChannels = () => createSelector(selectSettingsState, (state) => state.channels);
